import h from 'snabbdom/h';
import { map, filter } from 'ramda';
import { Map } from 'immutable';
import { getRect } from '../modules/player';
import { setAnnotationProperties } from '../modules/annotations';

let imgStyle = { cursor: 'pointer' };

const initialAnnotationState = Map({ open: false, pinned: false });

const bs = '5px solid #333';
const bi = '5px solid transparent';

const arrowCss = {
  position: 'absolute',
  display: 'inline-block',
  borderTop: bi, borderLeft: bi, borderRight: bi, borderBottom: bi,
  height: 0,
  width: 0,
  top: '', bottom: '', right: '', left: '',
};

const arrows = {
  tl: { ...arrowCss, ...{ borderRight: bs, top: '12px', left: '-10px', marginTop: '-5px' } },
  bl: { ...arrowCss, ...{ borderRight: bs, bottom: '8px', left: '-10px', marginTop: '-5px' } },
  tr:  { ...arrowCss, ...{ borderLeft: bs, top: '12px', right: '-10px', marginTop: '-5px' } },
  br:  { ...arrowCss, ...{ borderLeft: bs, bottom: '8px', right: '-10px', marginTop: '-5px' } },
};

const popupCss = { position: 'absolute', textAlign: 'left',
  left: '', top: '', bottom: '', right: '',
  transition: 'opacity 0.3s ease-out', webkitTransition: 'opacity 0.3s ease-out',
  fontFamily: 'sans-serif', delayed: { opacity: 1 }, remove: { opacity: 0 },
};

const popupCsses = {
  tl:  { ...popupCss, ...{ left: '30px', top: '0' } },
  bl:  { ...popupCss, ...{ left: '30px', bottom: '0' } },
  tr:   { ...popupCss, ...{ right: '30px', top: '0' } },
  br:  { ...popupCss, ...{ right: '30px', bottom: '0' } },
};

export function getAnnotationProperties(store, data) {
  const rect = getRect(store);
  const { position, normal, alpha } = data.position(store);
  if (!position) return false;

  const left = rect.width * position.x;
  const bottom = rect.height * position.y;
  const visible = !(left <  0 || left > rect.width - 24 || bottom < 0 || bottom > rect.height - 24) && data.visible;

  return {
    ...data.annotation,
    id: data.id,
    alpha,
    normal,
    position,
    top: rect.height - bottom,
    right: rect.width - left,
    bottom,
    left,
    visible,
  };
};

export default function(store) {
  const rect = getRect(store);
  const compact = filter((n) => n);

  return function (annotation) {
    const { id, text, left, bottom, visible, position, normal, alpha } = annotation; //data.position(store);
    if (position === undefined) return h('span');

    const state = store.getIn(['annotations', id]) || Map({ open: annotation.open, pinned: annotation.open });
    const open = state.get('open');
    const pinned = state.get('pinned');

    let tb = position.y > 0.5 ? 't' : 'b';
    let lr = position.x < 0.6 ? 'l' : 'r';
    let side = [tb, lr].join('');

    function click(ev) {
      ev.preventDefault();
      store.dispatch(setAnnotationProperties(id, {
        open: (!pinned ? true : !open),
        pinned: !pinned,
      }));
    }

    function mouseover(ev) {
      if (!pinned) store.dispatch(setAnnotationProperties(id, { open: true }));
    }

    function mouseout(ev) {
      if (!pinned) store.dispatch(setAnnotationProperties(id, { open: false }));
    };

    let children = [h('img', { style: { cursor: 'pointer' }, props: {
      width: 24,
      height: 24,
      src: `${__URLROOT__}/img/annotation-${open ? 'open' : 'closed'}-2.svg`,
    }, }),];

    if (open) {
      const textCss = {
        fontSize: '12px', padding: '10px', color: '#fff', backgroundColor: '#000',
        borderRadius: '3px', opacity: '0.8', cursor: 'pointer', lineHeight: 1.3,
        width: text.length > 10 ? (text.length > 50 ? '200px' : '150px') : '100px',
      };

      children.push(h('div', { style: popupCsses[side] }, compact([
        lr === 'l' && h('div', { key: side, style: arrows[side] }),
        h('div', { key: 'text', style: textCss, on: { click } }, text),
        lr === 'r' && h('div', { key: side, style: arrows[side] }),
      ])));
    }

    return h('div', {
      key: id,
      style: {
        visibility: visible ? 'visible' : 'hidden',
        opacity: alpha,
        position: 'absolute',
        left: `${Math.round(left)}px`,
        bottom: `${Math.round(bottom)}px`,
      },
      on: { click, mouseover, mouseout },
    }, children);
  };
}



// WEBPACK FOOTER //
// ./src/components/annotation.js